import { MaestroMarcas } from "./MaestroMarcas";
import { MaestroMarcasReferencias } from "./MaestroMarcasReferencias";

export class MaestroMarcasActualizacion {
    principal: MaestroMarcas;
    listaMarcasReferencias: MaestroMarcasReferencias[];
    listaMarcasReferenciasEliminar: MaestroMarcasReferencias[];
}